import { connect } from "react-redux";

import makeFilterBox from "../components/make_filter_box";
import { toggleAdvancedSearch } from "../actions/navigation";


export default (MainFilters, AdvancedFilters, breadcrumbsClickOverview) => {
  const mapStateToProps = (state) => {
    const showAdvancedSearch = state.filters.showAdvancedSearch;
    const isLocked = !!state.navigation.focusView.lockFilterBox;
    const saveSearchLoading = !!state.loading.savedSearchLoading;
    const showParametersPanel = state.filters.showParametersPanel;

    return { showAdvancedSearch, isLocked, saveSearchLoading, showParametersPanel };
  };

  const mapDispatchToProps = dispatch => ({
    toggleAdvancedSearch: () => dispatch(toggleAdvancedSearch()),
    returnToOverview: () => dispatch(breadcrumbsClickOverview())
  });

  const FilterBox = makeFilterBox(MainFilters, AdvancedFilters);
  return connect(mapStateToProps, mapDispatchToProps)(FilterBox);
};
